import { type ReactNode, useRef } from 'react';
import { SplashScene } from './SplashScene';

/**
 * Full-screen cinematic island behind the title screen and lobby. Mounted
 * once above both, so the camera keeps rolling when moving between them.
 */
export function TitleBackdrop() {
  const fadeRef = useRef<HTMLDivElement>(null);
  return (
    <div className="fixed inset-0 bg-[#c4d3e0]">
      <SplashScene fadeRef={fadeRef} />
      {/* Shot transitions fade through black (driven by SplashScene). */}
      <div ref={fadeRef} className="pointer-events-none absolute inset-0 bg-black" />
      {/* Soft shade at the bottom so panels read over any shot. */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/45 to-transparent" />
    </div>
  );
}

/** Wordmark at the top, `children` (the form or lobby panel) near the bottom. */
export function TitleLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex h-screen w-screen flex-col items-center justify-between overflow-hidden px-4 pb-[17vh] pt-[13vh] text-fg">
      <h1 className="title-rise text-[clamp(3.75rem,11vw,8rem)] font-bold leading-none tracking-[-0.04em] [text-shadow:0_1px_18px_rgb(0_0_0/0.28)]">
        territile
      </h1>
      {children}
    </div>
  );
}
